import React from 'react';

import Table from '../Table';
import Pagination from '../Pagination';

import getLoanNumber from '../../helpers/getLoanNumber';
import useUserRole from '../../hooks/useUserRole';
import createLoanStatusBadgeColor from '../../helpers/tables/createLoanStatusBadgeColor';

export default function LoansTable({
  rows,
  isFetching,
  pageTotal,
  currentPage,
  switchToPage,
  isLenderSection,
  total,
  isLoansPage,
}) {
  const { isLender } = useUserRole();

  const cols = [
    {
      title: 'Loan Number',
      keys: ['pixel_loan_number'],
      format: (value, row) => (isLender ? getLoanNumber(row) : value),
    },
    {
      title: 'Borrower',
      keys: ['borrowers[0].borrower_id'],
      link: (row) => `/loans/${row.id}?tab=Borrowers`,
      format: (value, row) => {
        if (row.borrowers?.length && row.borrowers[0]?._borrower?.TIN_type) {
          const primaryBorrower = row.borrowers.find(
            (borrower) => borrower.position === 'primary'
          );

          if (primaryBorrower) {
            return primaryBorrower?._borrower?.TIN_type === 'EIN'
              ? primaryBorrower?._borrower?.entity_name
              : `${primaryBorrower?._borrower?.first_name} ${primaryBorrower?._borrower?.last_name}`;
          }

          return '';
        }

        if (row._borrower_primary) {
          return row._borrower_primary?.TIN_type === 'EIN'
            ? row._borrower_primary?.entity_name
            : `${row._borrower_primary?.first_name} ${row._borrower_primary?.last_name}`;
        }

        return '';
      },
    },
    {
      title: 'Lender',
      keys: ['_lender.name'],
    },
    {
      title: 'Address',
      keys: isLenderSection
        ? [
            '_property.address_line_1',
            '_property.address_line_2',
            '_property.city',
            '_property.state',
            '_property.zip',
          ]
        : [
            '_property_of_loan.address_line_1',
            '_property_of_loan.address_line_2',
            '_property_of_loan.city',
            '_property_of_loan.state',
            '_property_of_loan.zip',
          ],
      format: (value, row) => {
        if (value && value.trim?.()) {
          return value;
        }
        if (row._borrower_primary && !isLenderSection) {
          return `${row._borrower_primary?.billing_address_line_1} ${row._borrower_primary?.billing_address_line_2} ${row._borrower_primary?.billing_city} ${row._borrower_primary?.billing_state} ${row._borrower_primary?.billing_zip}`;
        }

        return '';
      },
    },
    {
      title: 'Status',
      keys: ['status'],
      link: (row) => `/loans/${row.id}?tab=Loan`,
      type: 'badge',
      badgeColor: createLoanStatusBadgeColor,
    },
  ];

  const currentCols = isLoansPage
    ? cols
    : cols.filter((col) => col.title !== 'Lender');

  return (
    <>
      {/* Table */}
      <Table
        total={total}
        cols={currentCols}
        rows={rows}
        title="Loans"
        isFetching={isFetching}
        minHeight={565}
      />

      {/* Pagination */}
      <Pagination
        pageTotal={pageTotal}
        switchToPage={switchToPage}
        currentPage={currentPage}
      />
    </>
  );
}
